/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_SummaryInputs */

const vi_report_debt_summary = /** @type {(inputs: Report_Debt_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng hợp công nợ`)
};

/**

* @param {Report_Debt_SummaryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_summary = /** @type {((inputs?: Report_Debt_SummaryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_SummaryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_summary(inputs)
});